/**
 * Directive: dateConverter
 */
angular.module('acme.common.directive.dateConverter', [
  'acme.common.service.helpers'
])
.directive('dateConverter', ['HelpersService', function(HelpersService) {

    return {
      restrict: 'A',
      require: "ngModel",
      
      link: function (scope, element, attrs, ngModelCtrl) {

        var formatter = function(e) {
          var value = moment(ngModelCtrl.$viewValue);

          if (value.isValid()) {
            ngModelCtrl.$setViewValue(value.format(HelpersService.dateFormats.fieldDate.toUpperCase()));
            ngModelCtrl.$render();
            scope.$apply();
          }

        };

        element.bind('blur', formatter);

        scope.$on('$destroy', function() {
          element.unbind('blur', formatter);
        });

      }

    };

}]);